import React from 'react';
import {FaFacebook,FaLinkedinIn,FaTwitter,FaInstagram,FaGithub} from 'react-icons/fa';

const Footer = () => {
    return (
       <section className="footer">
           <div className="footer_links text-center">
               <p className="footer_heading">Reach out to us</p>
               <ul className="footer_social_links">
                   <li className="footer_social_link">
                        <FaFacebook className="footer_social_icon" />
                   </li>
                   <li className="footer_social_link">
                        <FaLinkedinIn className="footer_social__icon" />
                   </li>
                   <li className="footer_social_link">
                       <FaTwitter className="footer_social_icon" />
                   </li>
                   <li className="footer_social_link">
                       <FaInstagram className="footer_social_icon" />
                   </li>
                   <li className="footer_social_link">
                       <FaGithub className="footer_social_icon" />
                   </li>
               </ul>
               <p className="footer_heading">Call us Today:</p>
               <p className="footer_heading">0727632051</p>
                <p className="footer_text">@{new Date().getFullYear()}</p>
           </div>
       </section>
    )
};


export default Footer;